import { ChakraBox as Box, ChakraDivider as Divider } from "@airhelp/react-ui-components";
import { MAX_GRID_WIDTH } from "config/styleConsts";
import type { SbEditableComponentProps } from "types/storyblok";
import type { HorizontalDividerProps } from "./HorizontalDivider.d";

export const HorizontalDivider = ({
  myMobile = "12",
  myTablet = "12",
  myDesktop = "12",
  hideOnMobile = false,
  hideOnTablet = false,
  hideOnDesktop = false,
  pxDesktop = "4",
  pxTablet = "4",
  pxMobile = "4",

  sbEditable,
}: SbEditableComponentProps<HorizontalDividerProps>) => {
  const display = {
    base: hideOnMobile ? "none" : "block",
    md: hideOnTablet ? "none" : "block",
    lg: hideOnDesktop ? "none" : "block",
  };

  return (
    <Box w="full" mx="auto" px={{ base: pxMobile, md: pxTablet, lg: pxDesktop }} display={display} {...sbEditable}>
      <Divider
        my={{ base: myMobile, md: myTablet, lg: myDesktop }}
        mx="auto"
        width="full"
        maxWidth={MAX_GRID_WIDTH}
        opacity={1}
        borderColor="greyscale.400"
      />
    </Box>
  );
};
